<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-album
            :profil="profil"
        />

        <!-- Main -->
        <main>
            <div class="albumMainBody">

                <div class="albumPages">
                    <div class="albumPage --first"></div>
                    <div class="albumPage --second"></div>
                    <div class="albumPage --third"></div>
                    <div class="albumPage --fourth"></div>
                </div>    

                <button @click="$router.push({ name: 'profil' })" class="sideMenu__close"><span class="icon"></span></button>
                <div class="albumList__separator"></div>

                <!-- Úspechy -->
                <div class="albumListing__wrap">

                    <!-- 1. strana -->
                    <div class="albumList__half --first">
                        <!-- Header -->
                        <div class="albumList__heading mb-3 d-flex align-items-center justify-content-between">
                            <h2 class="mb-0">Moje úspechy <span class="icon --questionMark" @click="$bvModal.show('modalAlbumAnatomia')"></span></h2>
                            <p class="mb-0">Máš <span class="--bold">{{ countOwned }}</span> z celkových <span class="--bold">{{ countTotal }} úspechov</span></p>
                            <!--<p class="mb-0">Tvoja celková úspešnosť je <span data-toggle="modal" data-target="#successModal" class="--bold">{{ percOwned }}%</span></p>-->
                        </div>

                        <!-- Achievement box -->
                        <div v-if="album.uspechy" class="albumListing__list">
                            <div v-if="index >= startIndex && index <= (endIndex - 9)" 
                                 v-for="(uspech, index) in album.uspechy" 
                                 @click="checkItem(uspech, index)" 
                                 :class="'albumListing__item' + [(uspech.current == uspech.album_uspechy_max && uspech.collected == 1) ? ' --done' : (uspech.current == uspech.album_uspechy_max && uspech.collected != 1) ? ' --collect' : '']">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/uspechy/' + uspech.album_uspechy_img" alt="" class="img-fluid" >
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <p class="albumListing__name mb-0 --uspechHelp"> {{ uspech.album_uspechy_nadpis }} <span :id="'uspechInfo-' + index" class="icon"></span></p>
                                    <b-popover :target="'uspechInfo-' + index" triggers="hover focus" placement="top">
                                        <p>{{ uspech.album_uspechy_popis }}</p>
                                    </b-popover>
                                    <div class="albumListing__progress">
                                        <span class="albumListing__bar" :style="{ width: ((uspech.current / uspech.album_uspechy_max) * 100) + '%' }"></span>
                                    </div>
                                </div>

                                <span v-if="uspech.collected == 1" class="albumListing__checkmark"></span>
                                <span v-if="uspech.current == uspech.album_uspechy_max && uspech.collected != 1" class="productGridItem__collect__tag">Zobrať</span>

                            </div>
                        </div>
                    </div>

                    <!-- 2. strana -->
                    <div v-if="album.uspechy" class="albumList__half --second">
                        <!-- Achievement box -->
                        <div class="albumListing__list">
                            <div v-if="index >= (startIndex + 9) && index <= endIndex" 
                                 v-for="(uspech, index) in album.uspechy" 
                                 @click="checkItem(uspech, index)" 
                                 :class="'albumListing__item' + [(uspech.current == uspech.album_uspechy_max && uspech.collected == 1) ? ' --done' : (uspech.current == uspech.album_uspechy_max && uspech.collected != 1) ? ' --collect' : '']">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/uspechy/' + uspech.album_uspechy_img" alt="" class="img-fluid" >
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <p class="albumListing__name mb-0 --uspechHelp"> {{ uspech.album_uspechy_nadpis }} <span :id="'uspechInfo-' + index" class="icon"></span></p>
                                    <b-popover :target="'uspechInfo-' + index" triggers="hover focus" placement="top">
                                        <p>{{ uspech.album_uspechy_popis }}</p>
                                    </b-popover>
                                    <div class="albumListing__progress">
                                        <span class="albumListing__bar" :style="{ width: ((uspech.current / uspech.album_uspechy_max) * 100) + '%' }"></span>
                                    </div>
                                </div>

                                <span v-if="uspech.collected == 1" class="albumListing__checkmark"></span>
                                <span v-if="uspech.current == uspech.album_uspechy_max && uspech.collected != 1" class="productGridItem__collect__tag">Zobrať</span>

                            </div>
                        </div>
                    </div>

                </div>

                <!-- Paginácia -->
                <div v-if="prevPage != 0" @click="changePage(currentPage - 1)" class="albumListing__nav --prev">
                    <span class="icon --prev"></span>Predchádzajúca strana
                </div>
                <div v-if="nextPage != 0" @click="changePage(currentPage + 1)" class="albumListing__nav --next">
                    Ďalšia strana<span class="icon --next"></span>
                </div>

            </div>
        </main>

        <!-- Modal -->
        <b-modal id="modalAlbumAnatomia" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalAlbumAnatomiaTitle" aria-hidden="true" ref="modalAlbumAnatomia">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalAlbumAnatomia')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body" style="padding:0">
                <div class="text-center">

                    <h2 class="text-center">Nápoveda</h2>
                    <p class="text-18">Ďakujeme, že sa každý deň dobre staráš o svoju kravičku. Jupí, odteraz ťa za tvoju trpezlivosť a dôslednosť budeme odmeňovať! Každý z úspechov ti po kliknutí na "?" povie, čo musíš urobiť, aby si ho získal. Získaný úspech si tu v albume potvrdíš a dostaneš zaň prekvapko - vecičku do kolekcie, novú časť do anatómie, alebo odomkneš nový mliečny recept.</p>
                    
                </div>
            </div>
            <!-- .Content -->
        </b-modal>
        <!-- .Modal -->

        <!-- Modal -->
        <b-modal id="modalAlbumReward" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalAlbumRewardTitle" aria-hidden="true" ref="modalAlbumReward">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalAlbumReward')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body o-modalInfo">
                <div class="m-modalLostPassword__content text-center">

                    <img class="img-fluid mb-3" src="assets/img/winningPexeso.png" alt="">
                    <h2 class="m-modalWinningPexeso__name text-center">Gratulujeme!</h2>
                    <p class="text-center m-modalWinningPexeso__text mb-4">
                        Získal si úspech <strong>{{ modal_achievement }}</strong>.<br>
                        {{ modal_reward_text }} <strong>{{ modal_reward_nazov }}</strong>.
                    </p>

                    <div class="text-center">
                        <button @click="$bvModal.hide('modalAlbumReward')" class="btn --primary">Pokračovať</button>
                    </div>

                </div>
            </div>
            <!-- .Content -->
        </b-modal>
        <!-- .Modal -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderObchod from '../partials/HeaderObchod.vue'
    import MenuAlbum    from '../partials/MenuAlbum.vue'
    export default {
        components: {
            HeaderObchod,
            MenuAlbum
        },
        props: [
            'profil',
            'album',
            'error'
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'album')
            this.toggleBodyClass('addClass', '--uspechy')
            if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                this.$emit('updateProfil')
            }

            sessionStorage.setItem("album-uspechy", "refresh") // obnovenie albumu uspechov pri každom otvorení
            this.getAlbumData('uspechy')
            this.checkPagination()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'album')
            this.toggleBodyClass('removeClass', '--uspechy')
        },
        updated() {
            if (this.updated == 0) {
                this.getAlbumData('uspechy')
            }
        },
        data() {
            return {
                countTotal: 0,
                countOwned: 0,
                percOwned: 0,

                prevPage: 0,
                currentPage: 0,
                nextPage: 0,
                startIndex: 0,
                endIndex: 17,

                modal_achievement: '',
                modal_reward_text: '',
                modal_reward_nazov: '',

                updated: 0,

                isDisabled: false,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },


            // mounted
            getAlbumData(typ) {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1

                    if ( typeof(this.album.uspechy) == 'undefined' || sessionStorage.getItem("album-uspechy") ) {
                        EventService.getAlbumData(typ)
                            .then(response => {
                                //console.log(response.data)
                                //sessionStorage.removeItem("album-uspechy") // obnovenie albumu uspechov pri každom otvorení

                                // progres pre splnené úspechy
                                var items = response.data.data
                                this.countOwned = 0
                                this.countTotal = items.length

                                for (var i = 0; i < items.length; i++) {
                                    // album progres
                                    items[i].current = 0
                                    items[i].collected = 0
                                    var key = this.profil.pouzivatel_id.album_pouzivatela.findIndex(repo => 
                                        repo.album_item_id == items[i].id &&  repo.repozitar_albumu_category == "uspechy"
                                    )

                                    if (key >= 0) {
                                        items[i].current = parseInt(this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current)
                                        items[i].collected = parseInt(this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_collected)
                                        if (parseInt(this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current) == parseInt(items[i].album_uspechy_max)) {
                                            this.countOwned += 1
                                        }
                                    }
                                }
                                this.percOwned = ((this.countOwned / this.countTotal) * 100).toString().substring(0, 5)
                                this.checkPagination()

                                // emit alternative
                                this.$set(this.album, 'uspechy', items)
                            })
                            .catch(error => {
                                this.responseType = 'warning'
                                this.responseText = error
                            })

                    } else {
                        for (var i = 0; i < this.album.uspechy.length; i++) {
                            if (parseInt(this.album.uspechy[i].current) == parseInt(this.album.uspechy[i].album_uspechy_max)) {
                                this.countOwned += 1
                            }
                        }
                        this.countTotal = this.album.uspechy.length
                        this.percOwned  = ((this.countOwned / this.countTotal) * 100).toString().substring(0, 5)
                    }
                }
            },

            checkPagination() {
                if (this.countTotal > 18 || (typeof(this.album.uspechy) != 'undefined' && this.album.uspechy.length > 18)) {
                    this.nextPage = 1
                }
            },


            // click
            checkItem(uspech, index) {
                if (uspech.current == uspech.album_uspechy_max && uspech.collected != 1) {
                    this.collectReward(index)
                }
            },

            changePage(x) {
                // draw current page
                this.startIndex = 0 + (18 * x)
                this.endIndex   = this.startIndex + 17

                // set pages
                this.nextPage    = 0
                this.prevPage    = x
                this.currentPage = x
                if ( this.endIndex < (this.countTotal - 1) || (typeof(this.album.uspechy) != 'undefined' && this.endIndex < (this.album.uspechy.length - 1)) ) {
                    this.nextPage = 1
                }

                //console.log(x + ': ' + this.startIndex + '-' + this.endIndex)
                //console.log(this.nextPage + ': ' + this.endIndex + '>' +this.countTotal)
            },

            collectReward(index) {
                if (!this.isDisabled) {
                    this.isDisabled = true
                    var key = this.profil.pouzivatel_id.album_pouzivatela.findIndex(repo => 
                        repo.album_item_id == this.album.uspechy[index].id &&  repo.repozitar_albumu_category == "uspechy"
                    )

                    if (key >= 0) {
                        if ( this.album.uspechy[index].current == parseInt(this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current) ) {
                            this.album.uspechy[index].collected = 1
                            this.modal_achievement = this.album.uspechy[index].album_uspechy_nadpis

                            EventService.collectReward(this.profil.pouzivatel_id.album_pouzivatela[key].id)
                                .then(response => {
                                    //console.log(response.data)
                                    if (response.status == 200) {
                                        this.modal_reward_text  = response.data.data.text
                                        this.modal_reward_nazov = response.data.data.nazov
                                        /*if (response.data.data.album_typ !== undefined) {
                                            if (response.data.data.album_typ == 'recepty') {
                                                this.modal_reward_text  = 'Za tento úspech dostávaš do receptára recept na'
                                            } else if (response.data.data.album_typ == 'anatomia') {
                                                this.modal_reward_text  = 'Odomkol si v anatómii kravičky časť'
                                            } else if (response.data.data.album_typ == 'kravicky') {
                                                this.modal_reward_text  = 'Do svojej kravičkovskej kolekcie získavaš'
                                            }
                                        }*/
                                        this.$bvModal.show('modalAlbumReward')
                                        this.$emit('update:album', this.album)

                                        sessionStorage.setItem("album-kravicky", "refresh")
                                        sessionStorage.setItem("album-anatomia", "refresh")
                                        sessionStorage.setItem("album-recepty", "refresh")

                                        this.$emit('updateProfil')
                                        this.isDisabled = false
                                    }
                                })
                                .catch(error => {
                                    this.responseType = 'warning'
                                    this.responseText = error
                                })
                        }
                    } else {
                        this.isDisabled = false
                    }
                }
            },
        }
    }
</script>